var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "error_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.98 4a7.98 7.98 0 1 0 0 15.96 7.98 7.98 0 0 0 0-15.96M2 11.98C2 6.468 6.468 2 11.98 2s9.98 4.468 9.98 9.98-4.468 9.98-9.98 9.98S2 17.492 2 11.98",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 15.01a1.13 1.13 0 1 0 0 2.26 1.13 1.13 0 0 0 0-2.26M12 6.74c.55 0 1 .45 1 1v5.32c0 .55-.45 1-1 1s-1-.45-1-1V7.74c0-.55.45-1 1-1"
})));
export default SvgError;